module.exports = __webpack_public_path__ + "static/media/promo-sorte-caminho.acf0a883.png";